import axios from 'axios'
import i18next from 'i18next';

import {requestHelper} from "../_helpers";
import {sourceConstants} from "../_constants";

// playlist link 
const server = requestHelper.getBaseUrl();

/**
 * This method fetches the UUID details
 * @param {string} uuid Unique identifier for the media
 */
function getMedia(uuid) {
    let link = server + "/api/sources/" + uuid;
    return axios.get(link)
        .then(res => {
            if(res.status === 200){
                return res.data
            }
        }).catch( error => {
            return handleSourceResponseError(error)
        });
}

/**
 * This method fetches the UUID details
 * @param {string} identifier Unique identifier for the media
 */
function getDefaultMedia(identifier="") {
    const stringUtils = require('underscore.string');
    const link = (!stringUtils.isBlank(identifier))
        ? server + "/api/sources/default?identifier=" + identifier
        : server + "/api/sources/default";

    return axios.get(link)
        .then(res => {
            if(res.status === 200){
                return res.data
            }
        }).catch( error => {
            return handleSourceResponseError(error);
        });
}

/**
 * Handles source response error cases
 * @param error the error response
 * @returns {Promise<never>}
 */
function handleSourceResponseError(error) {
    const t = i18next.t;

    // noinspection JSValidateTypes
    let res = {
        "status": 500,
        "errorMsg": t("Sorry, we're having technical issues. Please try again.")
    };

    if (error && error.response) {
        res.status = error.response.status;
        switch (res.status) {
            case 401:
                // noinspection JSValidateTypes
                res.errorMsg = t("Sorry, this media has restricted access.");
                break;

            case 402:
                // noinspection JSValidateTypes
                res.errorMsg = t("Sorry, there’s a problem with the account for the owner of this media.");
                break;

            case 403:
                // noinspection JSValidateTypes
                res.errorMsg = t("Sorry, you’ve not been granted access to this media.");   //default
                if(error.response.data){
                    // noinspection JSValidateTypes
                    const pendingGist = t("Gist is being prepared. Check back in a while.");
                    const unpublishedGist = t("Gist is ready. However, the owner of the media hasn't published it yet.");
                    // noinspection JSValidateTypes
                    const problematicSource = t("Oops! We're having some troubles. Check back in a bit, or contact us if this problem continues.");
                    switch(error.response.data){
                        case sourceConstants.SOURCE_STATUS_NEW:       res.errorMsg = pendingGist;       break;
                        case sourceConstants.SOURCE_STATUS_PENDING:   res.errorMsg = pendingGist;       break;
                        case sourceConstants.SOURCE_STATUS_READY:     res.errorMsg = unpublishedGist;   break;
                        case sourceConstants.SOURCE_STATUS_FAILED:    res.errorMsg = problematicSource; break;
                        default:    break;
                    }
                }
                break;

            case 404:
                // noinspection JSValidateTypes
                res.errorMsg = t("Coming Soon...");
                break;

            default:
                break;
        }
    }
    return Promise.reject(res);
}

/**
 * This function get the cloud information for the given resource
 * @param {*} uuid Identifier
 * @param {*} parameters Params for fetching content
 */
function getCloud(uuid, parameters) {
    let link = server + "/api/gists/" + uuid;

    if (parameters && parameters.version) {
        link += "?algorithm-version=" + parameters.version;
    }

    return axios.get(link)
        .then(res => {
            if(res.status === 200){
                return res.data
            }
        });
}

/**
 * This function sends the view increment request for the given uuid
 * @param {*} uuid Identifier
 */
function incrementViewCount(uuid) {
    let link = server + "/api/sources/" + uuid + "/view" ;
    return axios.post(link)
        .then(res => {
            return (res.status === 200);
        });
}

/**
 * Fetches transcripts for the given uuid
 *
 * @param uuid the uuid of the source whose transcript is desired
 */
function getTranscript(uuid) {
    let link = server + "/api/sources/" + uuid + "/transcript";
    return axios.get(link)
        .then(res => {
            if(res.status === 200){
                return res.data;
            }
        })
        .catch(() => {
            return Promise.reject();
        });
}

export { getMedia, getDefaultMedia, getCloud, incrementViewCount, getTranscript }
